let abortController = new AbortController()

/**
 * Attach the shared abort signal so in-flight calls can be cancelled together.
 *
 * @param {Object} config
 * @return {Object}
 */
export function attachAbortSignal(config) {
	if (!config.signal) {
		config.signal = abortController.signal
	}

	return config
}

/**
 * Abort every request that is still using the shared signal.
 *
 * @return {void}
 */
export function cancelInFlightRequests() {
	abortController.abort()
	abortController = new AbortController()
}
